import { Sound } from './Sound';
import { allAnswersRevealed } from './store/GameplayStateUtils';
import { gamePlayStore } from './store/GameplayStore';
import { startAppListening } from './store/Store';

// Trigger sounds from the store where they are not triggered from UI components

// Buzz in during Face Off
startAppListening({
	actionCreator: gamePlayStore.actions.faceOffBuzz,
	effect: () => { Sound.effects.Buzzer.play(); },
});

// Cheers when the board is cleared
startAppListening({
	actionCreator: gamePlayStore.actions.answer,
	effect: (_action, api) => {
		const questionBefore = gamePlayStore.selectors.currentQuestion(api.getOriginalState());
		const questionAfter = gamePlayStore.selectors.currentQuestion(api.getState());
		const phase = gamePlayStore.selectors.phase(api.getOriginalState());

		if ((phase !== 'reveal')
			&& questionBefore && questionAfter
			&& !allAnswersRevealed(questionBefore) && allAnswersRevealed(questionAfter)) {
			Sound.effects.BoardCleared.play();
		}
	},
});

// Wrong answer
startAppListening({
	actionCreator: gamePlayStore.actions.wrongAnswer,
	effect: (_action, api) => {
		const before = gamePlayStore.selectors.strikes(api.getOriginalState());
		const after = gamePlayStore.selectors.strikes(api.getState());
		const isLastStrike = (before.strikes < before.maxStrikes) && (after.strikes === after.maxStrikes);

		const soundId = Sound.effects.WrongAnswer.play();
		if (isLastStrike) {
			Sound.effects.WrongAnswer.on('end', () => {
				Sound.effects.StrikeOut.play();
			}, soundId);
		}
	},
});